import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routerList = []
function importAll (r) {
  r.keys().forEach(key => {
    routerList = routerList.concat(r(key).default)
  })
}
importAll(require.context('./modules/', true, /\.routes\.js/))

export default new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'exact_active',
  linkActiveClass: 'active',
  base: process.env.NODE_ENV !== 'production' ? '' : process.env.BASE_URL,
  routes: routerList,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})
